import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { Space, Popconfirm, message, Button } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, PageHeaderItem, dineroDisabledMask } from "../../../Components/Items";
import AgregarCarrera from "./AgregarCarrera/AgregarCarrera";
import EditarCarrera from "./EditarCarrera/EditarCarrera";
import dayjs from "dayjs";

class Carreras extends Component {
  state = {
    todasCarreras: [],
    loading: false,
    modalAgregarCarrera: false,
    modalEditarCarrera: false,
    modalEditarCarreraId: null,
  }
  componentDidMount() {
    this.consultarCarreras();
  }

  consultarCarreras() {
    this.setState({loading: true})
    axios
    .post(
      "carreras/selectTodasCarreras",
      { empresaId: this.props.empresaId },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      this.setState({loading: false})
      if (res.data.success === 2) {
          this.setState({
            todasCarreras: res.data.carreras.map((value) => {
              return {
                ...value,
                accion: { _id: value._id, estado: value.estado },
              };
            }),
          });
      }
    });
  }
  deshabilitarCarrera(value) {
    axios
      .post(
        "carreras/deshabilitarCarrera",
        { carreraId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Carrera deshabilitada");
        } else {
          message.error("Sucedio un error y no se pudo deshabilitar");
        }
        this.consultarCarreras();
      });
  }
  habilitarCarrera(value) {
    axios
      .post(
        "carreras/habilitarCarrera",
        { carreraId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Carrera habilitada");
        } else {
          message.error("Sucedio un error y no se pudo habilitar");
        }
        this.consultarCarreras();
      });
  }

  agregarCarrera() {
    this.setState({modalAgregarCarrera: true})
  }

  editarCarrera(value) {
    this.setState({modalEditarCarrera: true, modalEditarCarreraId: value})
  }
  cerrarModalAgregarCarrera() {
    this.setState({ modalAgregarCarrera: false });
    this.consultarCarreras();
  }
  cerrarModalEditarCarrera(){
    this.setState({modalEditarCarrera: false, modalEditarCarreraId: null})
    this.consultarCarreras()
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Distancia",
        dataIndex: "distancia",
        key: "distancia",
        sorter: (a, b) => {
          if (a.distancia < b.distancia) {
            return -1;
          }
          if (a.distancia > b.distancia) {
            return 1;
          }
          return 0;
        },
        render: (value) => value+' km',
        buscar: "distancia",
      },
      {
        title: "Precio",
        dataIndex: "precio",
        key: "precio",
        sorter: (a, b) => {
          if (a.precio < b.precio) {
            return -1;
          }
          if (a.precio > b.precio) {
            return 1;
          }
          return 0;
        },
        render: (value) => dineroDisabledMask(value),
        buscar: "precio",
      },
      {
        title: "Fecha Carrera",
        dataIndex: "fechaCarrera",
        key: "fechaCarrera",
        sorter: (a, b) => {
          if (a.fechaCarrera < b.fechaCarrera) {
            return -1;
          }
          if (a.fechaCarrera > b.fechaCarrera) {
            return 1;
          }
          return 0;
        },
        render: (value) => dayjs(value).format('DD/MM/YYYY'),
        buscar: "fechaCarrera",
      },
      {
        title: "Accion",
        dataIndex: "accion",
        key: "accion",
        render: (value) => (
          <Space size="middle">
            {
              <EditOutlined
                onClick={() => this.editarCarrera(value._id)}
                style={{ color: "blue" }}
              />
            }
            {
            <>
              {value.estado === 1 ? (
                <Popconfirm
                  title="Seguro que quieres deshabilitar esta carrera"
                  onConfirm={() => this.deshabilitarCarrera(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <CheckCircleOutlined style={{ color: "green" }} />
                </Popconfirm>
              ) : (
                <Popconfirm
                  title="Seguro que quieres habilitar esta carrera"
                  onConfirm={() => this.habilitarCarrera(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <StopOutlined style={{ color: "red" }} />
                </Popconfirm>
              )}
            </>
            }
          </Space>
        ),
      },
    ];
    return (
      <>
        <PageHeaderItem
          title="Carreras"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Button
              type="primary"
              key="agregarCarrera"
              onClick={this.agregarCarrera.bind(this)}
            >
              Agregar Carrera
            </Button>
          }
        />
        <TableItem
        loading={this.state.loading}
          size="small"
          dataSource={this.state.todasCarreras}
          columns={columns}
        />
        <AgregarCarrera
          visible={this.state.modalAgregarCarrera}
          cerrarModalAgregarCarrera={this.cerrarModalAgregarCarrera.bind(this)}
            />
                    <EditarCarrera
          visible={this.state.modalEditarCarrera}
          id={this.state.modalEditarCarreraId}
          cerrarModalEditarCarrera={this.cerrarModalEditarCarrera.bind(this)}
            />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
  };
};

export default connect(mapStateToProps)(Carreras);